<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading full-character-formatting" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For the audacity of hope.</p>
<p class="subsq dedication-content">“That which does not kill us makes us stronger.”</p>
<p class="subsq dedication-content"><i>— </i>Frederich Nietzsche</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4a7336d8